<template>
	<div class="table-list">
		<div class="table-headlines">
			<div class="main">
				<div @click="setAdSet(null)" class="back"><i class="fas fa-chevron-left fa-fw" /></div>

				<div class="title">
					<span @click="setCampaign(null)">{{ $t('google.ads.campaigns') }}</span>
					<span @click="setAdSet(null)">{{ $t('google.ads.adSets') }}</span>
					<span>{{ $t('google.ads.ads') }}</span>
				</div>
			</div>

			<div class="metrics">
				<div v-for="item in views[view]" class="metric">
					<i class="fa-fw" :class="item.icon" />
					<span>{{ item.label }}</span>
				</div>
			</div>
		</div>

		<div class="table-rows">
			<template v-if="items !== null"
					  v-for="(item, index) in filteredItems">
				<div :key="`ad-set-actual-${index}`"
					 class="table-row">
					<div class="list">
						<div class="total">
							<div class="main">
								<div class="name">{{ item.adGroup.name }}</div>
							</div>

							<div class="metrics">
								<div v-for="viewItem in views[view]" class="metric">
									<div class="metric-label">
										<i class="fa-fw" :class="viewItem.icon" />
										<span>{{ viewItem.label }}</span>
									</div>


									<span v-if="formatValue(item, viewItem) !== null">{{ formatValue(item, viewItem) }}</span>
									<span v-else>-</span>
								</div>
							</div>
						</div>

						<div class="item">
							<div class="main">
								<div class="icon"><i class="far fa-desktop fa-fw" /></div>
								<div class="name">Desktop</div>
							</div>

							<div class="metrics">
								<div v-for="viewItem in views[view]" class="metric">
									<div class="metric-label">
										<i class="fa-fw" :class="viewItem.icon" />
										<span>{{ viewItem.label }}</span>
									</div>


									<span v-if="formatValueBreakdown(item.adGroupAd.ad.id, viewItem, 'DESKTOP') !== null">{{ formatValueBreakdown(item.adGroupAd.ad.id, viewItem, 'DESKTOP') }}</span>
									<span v-else>-</span>
								</div>
							</div>
						</div>

						<div class="item">
							<div class="main">
								<div class="icon"><i class="far fa-tablet fa-fw" /></div>
								<div class="name">Tablet</div>
							</div>

							<div class="metrics">
								<div v-for="viewItem in views[view]" class="metric">
									<div class="metric-label">
										<i class="fa-fw" :class="viewItem.icon" />
										<span>{{ viewItem.label }}</span>
									</div>


									<span v-if="formatValueBreakdown(item.adGroupAd.id, viewItem, 'TABLET') !== null">{{ formatValueBreakdown(item.adGroupAd.ad.id, viewItem, 'TABLET') }}</span>
									<span v-else>-</span>
								</div>
							</div>
						</div>

						<div class="item">
							<div class="main">
								<div class="icon"><i class="far fa-mobile fa-fw" /></div>
								<div class="name">Mobile</div>
							</div>

							<div class="metrics">
								<div v-for="viewItem in views[view]" class="metric">
									<div class="metric-label">
										<i class="fa-fw" :class="viewItem.icon" />
										<span>{{ viewItem.label }}</span>
									</div>


									<span v-if="formatValueBreakdown(item.adGroupAd.ad.id, viewItem, 'MOBILE') !== null">{{ formatValueBreakdown(item.adGroupAd.ad.id, viewItem, 'MOBILE') }}</span>
									<span v-else>-</span>
								</div>
							</div>
						</div>

						<div v-if="item.adGroupAd.ad.type === 'EXPANDED_TEXT_AD'"
							 class="ad-preview">
							<div class="headline"
								 v-if="!! item.adGroupAd.ad.expandedTextAd.headlinePart1"
								 v-text="item.adGroupAd.ad.expandedTextAd.headlinePart1"
							/>

							<div class="headline"
								 v-if="!! item.adGroupAd.ad.expandedTextAd.headlinePart2"
								 v-text="item.adGroupAd.ad.expandedTextAd.headlinePart2"
							/>

							<div class="link">{{ customer.domain }}</div>

							<div class="description"
								 v-if="!! item.adGroupAd.ad.expandedTextAd.description"
								 v-text="item.adGroupAd.ad.expandedTextAd.description"
							/>

							<div class="description"
								 v-if="!! item.adGroupAd.ad.expandedTextAd.description2"
								 v-text="item.adGroupAd.ad.expandedTextAd.description2"
							/>
						</div>
					</div>
				</div>

				<ad-insights :ad="item" />
			</template>

			<div v-if="items === null"
				 v-for="n in 20"
				 :key="`placeholder-${n}`"
				 class="table-row">
				<div class="mock main">
					<div class="name">Name here</div>
				</div>

				<div class="mock metrics">
					<div v-for="item in views[view]" class="metric">
						<div class="metric-label">
							<i class="fa-fw" :class="item.icon" />
							<span>{{ item.label }}</span>
						</div>

						<span>XYZ</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
div.table-list {
	display: flex;
	flex-direction: column;
	border: 1px solid #eee;
	border-radius: 8px;
	background-color: #fff;

	.main {
		width: 320px;
	}

	> div.table-headlines {
		display: flex;
		align-items: center;
		min-height: 60px;
		gap: 20px;
		border-bottom: 1px solid #eee;

		color: #1f1f1f;
		font-size: 16px;
		font-weight: 600;

		.controls {
			display: flex;
			align-items: center;
			gap: 6px;

			margin-left: auto;

			.search {
				position: relative;
				border: 1px solid #ccc;
				border-radius: 6px;
				overflow: hidden;

				> div.icon {
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 0 0 0 8px;
					position: absolute;
					pointer-events: none;
					touch-action: none;
					top: 0;
					bottom: 0;
					left: 0;
					font-size: 16px;
				}

				input {
					height: 36px;
					border: 0;
					outline: 0;
					box-shadow: none;
					padding: 0 14px 0 36px;
					line-height: 100%;
					font-size: 14px;
					font-weight: 400;
				}
			}
		}

		> div.main {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 15px 25px;

			> div.back {
				color: #000;
				font-size: 16px;
				min-width: 30px;
				min-height: 30px;
				width: 30px;
				height: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				cursor: pointer;
				user-select: none;

				&:hover {
					cursor: pointer;
					user-select: none;
					background-color: #eee;
				}
			}

			> div.title {
				> span {
					color: #9f9f9f;
					font-weight: 400;

					&:after {
						color: #9f9f9f;
						display: inline-block;
						padding: 0 7px;
						content: '/';
					}

					&:hover {
						cursor: pointer;
						user-select: none;
						color: #000;
						text-decoration: underline;
					}

					&:last-child {
						color: #000;
						font-weight: 500;

						&:after {
							display: none;
						}
					}
				}
			}
		}

		> div.metrics {
			display: flex;
			flex: 1;

			> div.metric {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				gap: 4px;

				padding: 15px 25px;
				min-height: 100%;

				flex: 1 1 0;
				width: 0;

				i {
					font-size: 20px;
				}

				font-size: 12px;
				font-weight: 500;
			}
		}
	}

	> div.table-rows {
		display: flex;
		flex-direction: column;

		> div.table-row {
			display: flex;
			gap: 20px;
			border-bottom: 1px solid #eee;

			&:nth-child(odd) {
				background-color: #fafafa;
			}

			.main {
				display: flex;
				align-items: center;
				gap: 10px;
				padding: 15px 25px;

				.name {
					color: #000;
					font-size: 15px;
					font-weight: 600;
				}
			}

			div.metrics {
				display: flex;
				flex: 1;

				> div.metric {

					flex: 1 1 0;
					width: 0;

					padding: 15px 25px;

					display: flex;
					align-items: center;
					justify-content: center;

					.metric-label {
						display: none;
					}

					&:nth-child(odd) {
						background-color: rgba(0, 0, 0, .02);
					}

					> span {
						padding: 4px 4px;
						line-height: 100%;
						font-size: 13px;
						font-weight: 500;
					}
				}
			}

			div.list {
				display: flex;
				flex-direction: column;

				width: 100%;

				> div {
					display: flex;
					gap: 20px;

					&.item {
						.main,
						.metrics .metric {
							padding: 8px 25px;

							span {
								color: #5e5e5e;
								font-weight: 400;
							}
						}

						&:nth-child(2) {
							.main,
							.metrics .metric {
								padding-top: 0;
							}
						}

						&:last-child {
							.main,
							.metrics .metric {
								padding-bottom: 15px;
							}
						}

						.main * {
							color: #5e5e5e;
							font-size: 13px;
							font-weight: 400;
						}
					}
				}
			}
		}
	}
}

@media(max-width: 750px) {
	div.table-list {
		.main {
			width: 100%;
		}

		> div.table-headlines {
			> div.main {
				padding: 15px !important;
			}

			> div.metrics {
				display: none;
			}
		}

		> div.table-rows {
			> div.table-row {
				display: flex;
				flex-direction: column;
				padding: 0 !important;

				div.main {
					flex: 0;
					padding: 15px 15px 0 15px !important;
				}

				div.metrics {
					flex: 0;

					display: flex;
					flex-direction: column;
					align-items: flex-start;

					> div.metric {
						display: flex;
						width: 100%;
						justify-content: space-between;
						border-bottom: 1px solid #eee;
						padding: 25px 15px !important;

						&:last-child {
							border-bottom: 0;
						}
					}

					.metric-label {
						display: flex !important;
						align-items: center;
						gap: 6px;

						font-weight: 500;

						i {
							color: #274fd2;
						}
					}
				}

				> div.list > div {
					flex-direction: column;
				}
			}
		}
	}
}


.ad-preview {
	font-family: Arial, sans-serif !important;
	background: white;
	line-height: 1.2;
	padding: 25px;
	border-top: 1px solid #ddd;

	display: flex !important;
	flex-direction: column !important;
	gap: 0px !important;

	.headline {
		font-size: 18px;
		line-height: inherit;
		color: #1a0dab;
	}

	.link {
		display: block;
		font-size: 14px;
		line-height: 16px;
		color: #047c2b;
		margin: 4px 0;
	}

	.description {
		font-weight: normal;
		font-size: 14px;
		line-height: 1.6;
		color: #545454;
	}
}
</style>

<script>
import {mapGetters} from "vuex";

const GoogleAdsService = require('@/services/google-ads/GoogleAdsService')
import datepickerMixin from '@/app/datepicker/datepicker.mixin'
import marketingMixin from '@/mixins/marketingMixin'

import moment from 'moment'
import AdInsights from './AdInsights'

export default {
	mixins: [
		datepickerMixin,
		marketingMixin
	],

	props: {
		network: {
			type: String,
			required: false
		},

		networks: {
			type: Object
		},

		views: {
			type: Object,
			required: true
		},

		status: {
			type: String,
			required: true
		},

		view: {
			type: String,
			required: true
		},

		campaign: {
			type: Object,
			required: false,
			default: null
		},

		adSet: {
			type: Object,
			required: false,
			default: null
		},

		ad: {
			type: Object,
			required: false,
			default: null
		},

		query: {
			type: String,
			required: false,
			default: ''
		}
	},

	data: () => ({
		items: null,
		breakdowns: null,
		limit: null,
		page: 1,
		adInsights: []
	}),

	computed: {
		...mapGetters("customer", {
			customer: "getCustomer",
		}),

		...mapGetters('ghost', {
			isDemo: 'isDemo',
		}),

		filteredItems() {
			const query = String(this.query || '').toLowerCase()

			if (query.length === 0) {
				return this.items
			}

			return this.items.filter(item => String(item.adGroup.name || '').toLowerCase().includes(query))
		},

		integrationId() {
			if (this.isDemo) {
				return 'demo-id'
			}

			const integrations = this.customer.integrations

			const match = integrations.find(integration => integration.service.name === "Google Ads")

			return !! match
				? match.id
				: null
		},

		orderBy() {
			return this.views[this.view].reduce(
				(carry, item) => {
					if (!! carry || item.source !== 'metrics') {
						return carry
					}

					return `metrics.${item.field} DESC`
				},
				null
			)
		}
	},

	watch: {
		status() {
			this.reset()
			this.onLoad()
		},

		network() {
			this.reset()
			this.onLoad()
		}
	},

	mounted() {
		this.onLoad()
	},

	methods: {
		reset() {
			this.page = 1
			this.items = null
			this.breakdowns = null
		},

		onLoad() {
			GoogleAdsService.fetchAds(
				this.from,
				this.to,
				this.integrationId,
				this.adSet.adGroup.id,
				(response) => {
					this.items = response.data
				},
				(res) => {
					// @TODO: Error
				},
				this.limit,
				this.page,
				this.networks[this.network].networks,
				true,
				this.status === 'active'
					? ['ENABLED']
					: ['PAUSED', 'REMOVED'],
			)

			GoogleAdsService.fetchAds(
				this.from,
				this.to,
				this.integrationId,
				this.adSet.adGroup.id,
				(response) => {
					this.breakdowns = response.data
				},
				(res) => {
					// @TODO: Error
				},
				this.limit,
				this.page,
				this.networks[this.network].networks,
				false,
				this.status === 'active'
					? ['ENABLED']
					: ['PAUSED', 'REMOVED'],
				this.orderBy
			)
		},

		formatValue(item, metric) {
			let value = null

			if (metric.source === 'metrics') {
				value = item.metrics[metric.field]
			} else if (metric.source === 'calculation') {
				value = metric.calculation(item.metrics, item)
			}

			if (! value) {
				return null
			}

			const type = metric.type

			switch (type) {
				case 'currency':
					return this.marketingFormat(
						Number(value) / 1000000,
						type,
						{ currency: item.customer.currencyCode }
					)

				default:
					return this.marketingFormat(
						value,
						type
					)
			}
		},

		formatValueBreakdown(id, metric, device) {
			const item = (this.breakdowns || []).find(i =>
				i.segments.device === device &&
				i.adGroupAd.ad.id === id
			)

			if (! item) {
				return null
			}

			let value = null

			if (metric.source === 'metrics') {
				value = item.metrics[metric.field]
			} else if (metric.source === 'calculation') {
				value = metric.calculation(item.metrics, item)
			}

			if (! value) {
				return null
			}

			const type = metric.type

			switch (type) {
				case 'currency':
					return this.marketingFormat(
						Number(value) / 1000000,
						type,
						{ currency: item.customer.currencyCode }
					)

				default:
					return this.marketingFormat(
						value,
						type
					)
			}
		},

		setCampaign(campaign) {
			this.$emit('campaign', campaign)
		},

		setAdSet(adSet) {
			this.$emit('adSet', adSet)
		},

		setAd(ad) {
			this.$emit('ad', ad)
		},

		formatDate(date) {
			return moment(date).format('ll')
		}
	},

	components: {
		AdInsights
	}
}
</script>
